module.exports = __webpack_public_path__ + "static/img/myprize.a655e9f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/myprize.png
// module id = 8IR0
// module chunks = 1